import React from 'react'
import Header from './Components/Header'
import MainHeader from './Components/MainHeader'
import ContactPageSection from './Components/ContactPageSection'
import Footer from './Components/Footer'
import SEOHelmet from './Components/SEOHelmet'

const ContactUs = () => {
    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.octalbees.com/"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Contact Us",
                "item": "https://www.octalbees.com/contact-us"
            }
        ]
    };

    return (
        <div style={{ backgroundColor: '#05000a', minHeight: '100vh' }}>
            <SEOHelmet
                title="Contact Octalbees – Let's Build Something Great"
                description="Get in touch with Octalbees for web development, app development, AI solutions, and digital marketing services. Let's discuss your project today."
                path="/contact-us"
                breadcrumbSchema={breadcrumbSchema}
            />
            <Header />
            <MainHeader />
            <ContactPageSection />
            <Footer />
        </div>
    )
}

export default ContactUs